import React from "react";
import { Divider } from "@mui/material";
import { useTheme } from "../components/hooks/useTheme";
import useGeneral from "../components/hooks/useGeneral";
import moment from "moment";

type Props = {
  id: number;
  userName: string;
  createdDate: string;
  notes: string;
  deleteTheComment: (id: number) => void;
};

export default function AddComments({ id, userName, createdDate, notes, deleteTheComment }: Props) {
  const { themeStyles } = useTheme();
  const { dateFormat }: any = useGeneral();

  return (
    <>
      <div className="w-full flex justify-between flex-row mt-2">
        <h6 className={`text-xs ${themeStyles.main.textHeadingColor}`}>{userName}</h6>
        <div className="w-1/2">
          <p className={`text-xs w-full break-words ${themeStyles.main.textHeadingColor}`}>{notes}</p>
        </div>
        <div className="flex gap-1.5 items-center ">
          <p className={`text-xs ${themeStyles.main.textHeadingColor}`}>
            {moment(new Date(createdDate)).format(dateFormat + " hh:mm a")}
          </p>
          <p className="text-xs text-center m-0">
            <span className={`material-symbols-outlined text-[20px] text-[#D92D20] hover:cursor-pointer`} onClick={() => deleteTheComment(id)}>
              delete
            </span>
          </p>
        </div>
      </div>

      <Divider className={`w-full ${themeStyles.divider.bg}`} />
    </>
  );

}
